import { omit } from 'lodash';
import ensureStringIsWrapped from 'src/utils/stringOperations/ensureStringIsWrapped';
function cleanUpRecordForRpcConsumption(cols, record) {
    let modifiedRecord = Object.assign({}, record);
    for (const col of cols) {
        if (col.type === 'row_menu')
            modifiedRecord = omit(modifiedRecord, 'row_menu');
        const field = col.field;
        const value = record[field];
        if (value !== undefined && col.isArray) {
            // @ts-expect-error
            modifiedRecord = Object.assign(Object.assign({}, modifiedRecord), { [field]: ensureStringIsWrapped(value, ['{', '}']) });
        }
    }
    return modifiedRecord;
}
export default function cleanUpRecordsForRpcConsumption(cols, records) {
    const result = records.map(r => cleanUpRecordForRpcConsumption(cols, r));
    return result;
}
